import React from "react";
import {Controller} from "react-hook-form";
import {RadioGroup, ReversedRadioButton} from "react-radio-buttons";
import {FormattedMessage, useIntl} from "react-intl";

function HomeMortgageStart({ register, watchHomeMortgageStartNotKnown,  control, paidOff }) {
  const intl = useIntl();
  return (
  <div>
    {!watchHomeMortgageStartNotKnown &&
    <div className='ct-input_wrapper'>
      <div className="ct-step__body-subquestion">
        <FormattedMessage id={'stepParts.homeMortgageStart.startDate'}
                          defaultMessage={'{question}'}
                          values={{
                            question: (paidOff) ?
                            intl.formatMessage({id: 'stepParts.homeMortgageStart.startDate.paidOff', defaultMessage: 'Wat is de startdatum van de hypotheek?*'}) :
                            intl.formatMessage({id: 'stepParts.homeMortgageStart.startDate.notPaidOff', defaultMessage: 'Wat is de startdatum van de annuïtaire/lineaire hypotheek?*'})
                          }}
        />
      </div>
      <div className='ct-input'>
        <input
        className=''
        name="HomeMortgageStart"
        type="date"
        ref={register({required: true})}
        ></input>
      </div>
    </div>
    }

    <div className="ct-input_wrapper">

      <label className="ct-checkbox"><span className='ct-step__body-subquestion'>
        <FormattedMessage id={'stepParts.homeMortgageStart.dataNotKnown'} defaultMessage={'Ik weet de exacte datum niet zeker'} />
      </span>
        <input name="HomeMortgageStartNotKnown"
               type="checkbox"
               value="true"
               ref={register({ required: false })}></input>
        <span className="checkmark"></span>
      </label>

    </div>

    {watchHomeMortgageStartNotKnown &&
    <div>
      <div className="ct-step__body-subquestion">

        <FormattedMessage id={'stepParts.homeMortgageStart.before2013'} defaultMessage={'Om een goede indicatie van de nieuwe maximale hypotheek te geven, willen we graag weten of de hypotheek voor 1-1-2013 is gestart'} />
      </div>

      <Controller
      as={
        <RadioGroup
        horizontal
        className="ct-step__radio-group"
        >
          <ReversedRadioButton
          value="true"
          rootColor="#000000"
          pointColor="#000000"
          iconInnerSize={18}
          iconSize={18}
          >
            <FormattedMessage id={'stepParts.homeMortgageStart.before2013.yes'} defaultMessage={'Ja'} />
          </ReversedRadioButton>

          <ReversedRadioButton
          value="false"
          rootColor="#000000"
          pointColor="#000000"
          iconInnerSize={18}
          iconSize={18}
          >
            <FormattedMessage id={'stepParts.homeMortgageStart.before2013.no'} defaultMessage={'Nee'} />
          </ReversedRadioButton>
        </RadioGroup>
      }
      defaultValue="false"
      name="HomeMortgageStartBefore2013"
      control={control}
      />

    </div>
  }

  </div>
  )};

export default HomeMortgageStart;
